module.exports = __webpack_public_path__ + "img/6.c1e88a41.gif";